import moment from 'moment';
export class AutomaticDiscountInputModel {
    constructor(payload) {
        const { uuid, active, name, endAt, startAt, usageLimit, value, discountType, oneTime, } = payload;
        this.uuid = uuid;
        this.name = name;
        this.endAt = endAt;
        this.startAt = startAt;
        this.usageLimit = usageLimit;
        this.value = value;
        this.active = active;
        this.discountType = discountType;
        this.oneTime = oneTime;
    }
    get formattedStartAt() {
        const startAt = new Date(this.startAt);
        return moment(startAt).format('YYYY-MM-DD');
    }
    get formattedStartAtTime() {
        const startAt = new Date(this.startAt);
        return moment(startAt).format('HH:mm');
    }
    get formattedEndAt() {
        const endAt = new Date(this.endAt);
        return moment(endAt).format('YYYY-MM-DD');
    }
    get formattedEndAtTime() {
        const endAt = new Date(this.endAt);
        return moment(endAt).format('HH:mm');
    }
}
